import React from 'react'
import {useTranslation} from 'react-i18next'
import {useLocation} from 'react-router-dom'

import {Box, Typography} from '@mui/material'

import {ReactComponent as ErrorSVG} from '@progyny/assets/images/error.svg'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'

const PartnerAgreementErrorPage = () => {
  const {t} = useTranslation()
  const location = useLocation()
  const errorMessage = new URLSearchParams(location.search).get('error_message')

  return (
    <SimpleMessageContainer
      image={ErrorSVG}
      message={
        <Box>
          <Typography variant={'h2'}>
            {t(
              'partners_agreement_partner_agreement_error_something_went_wrong'
            )}
          </Typography>
          <Typography variant={'body2'} mt={2}>
            {errorMessage ||
              t(
                'partners_agreement_partner_agreement_error_we_re_working_on_problem'
              )}
          </Typography>
        </Box>
      }
    />
  )
}

export default PartnerAgreementErrorPage
